export default {
    //Splash
    splash_message: 'İletişim ve eğitim platformu',

    //TTCC
    accept_ttcc: 'Şartlar ve Koşulları Kabul Et',

    //Login
    welcome: 'Hoş geldiniz!',
    welcome_message: 'dots, iletişim ve eğitimde yeni teknolojik ortağınız.',
    username: 'Kullanıcı adı',
    password: 'Şifre',
    code: 'Kod',
    recover_password: 'Şifre Kurtar',
    log_in: 'Giriş yap',
    log_in_biometrics: 'Biyometrik verilerle giriş yapın',
    create_user: 'Kullanıcı oluştur',
    recover_access_to_account: 'Hesabınıza erişimi kurtarmak için kullanıcı adınızı girin',
    back: 'Geri',
    enter_new_password: 'Kodu ve yeni şifrenizi girin',
    enter_code: 'Kodu girin',
    new_password: 'Yeni şifre',
    repeat_new_password: 'Yeni şifreyi tekrar girin',
    validate: 'Doğrula',
    complete_all_fields: 'Tüm alanları doldurun',
    passwords_do_not_match: 'Şifreler eşleşmiyor',
    user_created_successfully: 'Kullanıcı başarıyla oluşturuldu',
    create_user: 'Kullanıcı oluştur',
    required_fields: 'Gerekli alanlar',
    confirm_your_email: 'E-postanızı onaylayın',
    confirm_your_phone: 'Telefonunuzu onaylayın',
    confirm_password: 'Şifrenizi onaylayın',
    modifying_email: 'E-postanızı değiştiriyorsunuz',
    validate_code: 'Kodu doğrulayın',
    code_sent_successfully: 'Kod başarıyla gönderildi',
    password_reset: 'Şifreniz başarıyla sıfırlandı',
    enter_confirmation_code: 'Onay kodunuzu girin',
    enter_your_new_email: 'Yeni e-posta adresinizi girin',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Oops! Hesabınızı bulamadık',
    contact_the_administrator: 'Girdiğiniz kullanıcı mevcut gibi görünmüyor.\nDoğru yazıldığından emin olun\nveya yöneticiyle iletişime geçin.',
    invalid_user_or_pass: 'Geçersiz kullanıcı adı ve/veya şifre',
    info_is_not_correct: 'Bilgilerden bazıları doğru değil, lütfen tekrar deneyin.',
    enter_user: 'Lütfen bir kullanıcı adı girin',
    nonexistent_user: 'Mevcut olmayan kullanıcı. Lütfen tekrar deneyin.',
    incorrect_code: 'Geçersiz kod',
    change_saved_successfully: 'Değişiklik başarıyla kaydedildi',
    pass_changed_successfully: 'Şifre başarıyla değiştirildi',
    check_your_email: 'Doğrulama kodunu girmek için e-postanızı kontrol edin',
    eight_characters: '*8 karakterden fazla olmalı',
    one_uppercase_letter: '*En az 1 büyük harf içermeli',
    one_special_character: '*En az 1 özel karakter içermeli (@,$,!,#,?)',
    pass_requirements:
        'Aşağıdaki gereksinimleri karşılamalısınız:\n\n*8 karakterden fazla olmalı\n*En az 1 büyük harf içermeli\n*En az 1 özel karakter içermeli (örneğin: $, !, #, ?)',
    select_date: 'Bir tarih seçin',
    cannot_create_password: 'Şifre oluşturulamıyor',
    complete_your_details: 'Devam etmek için bilgilerinizi tamamlayın',
    validate_code: 'Kodu doğrulayın',
    enter_valid_number: 'Geçerli bir numara girmelisiniz',
    complete_numbers:
        '"15" ön eki çıkarılmalıdır, böylece son sayı toplamda 13 haneli olur, örneğin: +54 9 XXX XXX XXXX, kalan 10 haneyi tamamlamalısınız.',

    //Profile
    insufficient_permissions: 'Yetersiz izinler',
    permissions_are_required: 'Kamera ve foto galeriye erişim izinleri gereklidir.',
    choose_font: 'Kaynak seçin',
    where_do_you_want: 'Resmi nereden seçmek istersiniz?',
    camera: 'Kamera',
    gallery: 'Galeri',
    edit_photo: 'Fotoğrafı düzenle',
    cancel: 'İptal',
    save: 'Kaydet',
    app: 'Uygulama',
    support: 'Destek',
    other: 'Diğer',
    contact_channel: 'İletişim kanalı',
    select_the_contact_channel: 'İletişim kanalını seçin',
    subject: 'Konu',
    write_the_subject: 'Konuyu yazın',
    message: 'Mesaj',
    write_a_comment: 'Yorum yazın',
    send: 'Gönder',
    sent_successfully: 'Başarıyla gönderildi',
    thank_you_for_leaving_us_your_comments: 'Yorumlarınızı bıraktığınız için teşekkür ederiz, yakında sizinle iletişime geçilecektir.',
    close: 'Kapat',
    check_for_update: 'Güncellemeleri kontrol et',
    clear_cache: 'Önbelleği temizle',
    delete_account: 'Hesabı sil',
    log_out: 'Çıkış yap',
    notifications: 'Bildirimler',
    insufficient_permissions: 'Yetersiz izinler',
    permissions_to_access: 'Kamera ve foto galeriye erişim izinleri gereklidir.',
    choose_font: 'Kaynak seçin',
    select_the_image: 'Resmi nereden seçmek istersiniz?',
    change_language: 'Dili değiştir',
    change_language_title: 'Önemli!',
    change_language_message:
        'Bu eylemi gerçekleştirmek için internet bağlantınızın olması gerekir. Bu, çevrimdışı kullanım için indirilen içeriği siler. Değişikliğin, cihazınızın diline bağlı olarak uygulamanın yapısını değil, yalnızca uygulamanın içeriğini etkileyeceğini lütfen unutmayın.',
    logout_not_available: 'Çıkış yapılamıyor',
    cant_logout: 'Şu anda internet bağlantınız olmadığı için çıkış yapamazsınız. Lütfen bağlantınızı kontrol edin ve tekrar deneyin.',
    //nuevos al 01-08-2024
    cache_cleared: 'Кэш успешно очищен',
    deletes_the_content:
        'Это действие удаляет контент, загруженный для использования приложения в автономном режиме. Убедитесь, что вы подключены, чтобы продолжить просмотр.',
    error_uploading_image: 'Resim yükleme hatası: ',
    there_was_an_error: 'Resim yüklenirken bir hata oluştu. Lütfen tekrar deneyin.',
    //nuevos al 21-11-2024
    email: 'E-posta',
    phone: 'Telefon',
    name: 'Ad',
    last_name: 'Soyad',
    role: 'Rol',
    verify: 'Doğrula',
    verified: 'Doğrulandı',
    contact_channels: 'İletişim kanalları',
    editing_your_email: 'E-posta adresinizi düzenliyorsunuz',
    editing_your_phone: 'Telefon numaranızı düzenliyorsunuz',
    modifying_your_email:
        'E-posta adresinizi değiştiriyorsunuz, girmeniz için e-posta adresinize bir kod gönderilecektir. Eğer kodu almadıysanız, lütfen tekrar kontrol edin.',
    modifying_your_phone:
        'Cep telefonu numaranızı değiştiriyorsunuz, girmeniz için bir SMS kodu alacaksınız. Eğer kodu almadıysanız, lütfen tekrar kontrol edin.',

    //Notifications
    all: 'Tümü',
    unread: 'Okunmamış',
    read: 'Okundu',
    seen: 'Görüldü',
    notifications: 'Bildirimler',
    here_you_will_find: 'Burada tüm uyarıları ve bildirimleri bulacaksınız!',
    mark_all_read: 'Tümünü okundu olarak işaretle',
    you_have_no_notifications: 'Hiç bildiriminiz yok!',
    you_will_soon_start: 'Yakında yeni iletişimler almaya başlayacaksınız',

    //Buscador
    enter_your_search: 'Aramanızı girin',
    no_results: 'Sonuç bulunamadı',
    search_content: 'Sizi ilgilendiren içeriği arayın.',
    see: 'Görüntüle',
    results_in: 'sonuç',
    see_less_results: 'Daha az sonuç görüntüle',
    all: 'Tümü',
    wall: 'Duvar',
    learning: 'Öğrenme',
    benefits: 'Faydalar',
    portfolio: 'Portföy',
    retry: 'Tekrar dene',
    locked: 'Kilitli',
    pending: 'Beklemede',
    seen: 'Görüldü',
    approved: 'Onaylandı',

    //Posts
    see_them: 'Tümünü gör ',
    _comments: ' yorumlar',
    reactions_from_other_users: 'Diğer kullanıcılardan tepkiler',
    not_connected_to_the_network: 'Ağa bağlı değilsiniz',
    comment: 'Yorum',
    comments: 'Yorumlar',
    write_a_comment: 'Yorum yazın',
    no_content: 'İçerik yok',
    not_connected_to_the_network: 'Ağa bağlı değilsiniz',
    reaction: 'Tepki',
    reactions: 'Tepkiler',
    first_comment: 'İlk yorumu siz yapın!',
    no_comment: 'Bu gönderide henüz yorum yok.',
    write_a_comment: 'Yorum yazın',
    no_publications: 'Yayın yok',
    no_post_to_read: 'Okuyacak gönderi bulunmuyor.',
    views: 'görüntüleme',
    reply: 'Yanıtla',
    see: 'Gör ',
    more_answers: 'daha fazla yanıt',
    hide: 'Gizle ',
    answers: ' yanıt',
    no_reactions: 'Henüz tepki yok!',
    leave_your_reaction: 'İlk tepkinizi bırakın.',
    //nuevos al 01-08-2024
    full_survey: 'Anketi tamamladınız!',
    thanks_for_participating: 'Katıldığınız için teşekkürler! Daha fazla güncelleme için duvara göz atın.',
    sent_automatically: 'Bağlantınızı yeniden sağladığınızda otomatik olarak gönderilecektir.',
    no_post_saved: 'Henüz kaydedilmiş gönderi yok',
    see_your_favorite_content: 'Burada favori içeriğinizi göreceksiniz.',
    //fechas
    instant: 'Birkaç an önce',
    hourFirst: 'Önce ',
    hour: ' saat',
    hours: ' saat',
    day: ' gün',
    days: ' gün',

    //Learning
    congratulations: 'Tebrikler!',
    you_approved: 'Başarılı oldunuz ',
    you_completed: 'Bu kursu tamamladınız',
    you_disapproved: 'Başarısız değerlendirme',
    score: 'Puan:',
    return_to_course: 'Anasayfaya Geri Dön',
    retry: 'Tekrar dene',
    it_is_available: 'Şimdi kullanılabilir durumda',
    total_course_evaluation: 'Toplam kurs değerlendirmesi',
    evaluate_me: 'BENİ DEĞERLENDİR',
    completed_the_course: 'Kursu tamamladınız',
    pending_approval: 'Onay bekleniyor',
    return: 'Geri',
    continue_course: 'Kursa devam et',
    you_have_made: 'Tamamladınız ',
    of_the_course: ' kursun',
    locked: 'kilitli',
    pending: 'beklemede',
    seen: 'görüldü',
    complete: 'tamamlandı',
    reprobate: 'başarısız',
    sync_pend: 'senk. bek.',
    in_progress: 'devam ediyor',
    perform_evaluation: 'Değerlendirme yap',
    next_content: 'Sonraki içerik',
    you_completed_all: 'Tüm içerikleri tamamladınız',
    final_evaluation: 'SON DEĞERLENDİRME',
    retry_mayus: 'TEKRAR',
    see_more: '...daha fazla',
    see_less: '...daha az',
    back_to_course: 'KURSA GERİ DÖN',
    click_to_see: 'Görüntülemek için tıklayın',
    //Evaluaciones
    evaluation: 'Değerlendirme: ',
    of: ' / ',
    loading_evaluation: 'Değerlendirme yükleniyor...',
    select_option: 'Devam etmek için bir seçenek seçmelisiniz',
    select_one_answer: 'Lütfen her soru için en az bir cevap seçin.',
    exit_evaluation: 'Değerlendirmeyi çıkmak istiyor musunuz?',
    your_answers_will_not_be_saved: 'Şu anda çıkarsanız cevaplarınız kaydedilmeyecektir',
    continue_evaluation: 'Değerlendirmeye devam et',
    leave_anyway: 'Yine de çık',
    try_again: 'Tekrar dene!',
    passed_the_evaluation: 'Değerlendirmeyi geçtiniz',
    start_the_course_again: 'Değerlendirmeyi geçmek için yeterli notu alamadınız. Geçebilmek için kursa tekrar başlayın.',
    evaluation_pending_approval: 'Değerlendirme onay bekliyor',
    notification_result_evaluation: 'Değerlendirme sonucunuzla ilgili bildirim alacaksınız',
    write_here: 'Buraya yazın...',
    close: 'Kapat',
    confirm: 'Onayla',
    sync_pending: 'Senkronizasyon bekliyor',
    view_certificate: 'Sertifikayı Görüntüle',

    // nuevos al 27-01-2025
    course_download_in_process: 'Kurs indiriliyor',
    course_is_downloading:
        'Lütfen birkaç saniye bekleyin. Kurs indiriliyor, böylece tüm içeriği çevrimdışı erişimle sorunsuz bir şekilde görüntüleyebilirsiniz.',
    downloaded_course: 'Kurs başarıyla indirildi',
    you_can_train_offline: 'Tamam! Artık çevrimdışı eğitim yapabilirsiniz.',
    delete_offline_course: 'Bu kursun çevrimdışı indirmesini silmek istiyor musunuz?',
    not_view_course_offline: 'Bu kursu çevrimdışı modda görüntüleyemezsiniz.',
    course_is_not_available: 'Kurs artık mevcut değil...',
    not_available_offline: 'Artık çevrimdışı mevcut değil, ancak ihtiyaç duyduğunuzda tekrar indirebilirsiniz.',
    content_download_in_process: 'İçerik indiriliyor',
    content_is_downloading: 'Lütfen birkaç saniye bekleyin. İçerik indiriliyor, böylece çevrimdışı olarak sorunsuz bir şekilde erişebilirsiniz.',
    downloaded_content: 'İçerik başarıyla indirildi',
    delete_offline_content: 'Çevrimdışı içeriği silmek istiyor musunuz?',
    not_view_content_offline: 'Bunu sildiğinizde, içeriğe çevrimdışı erişim sağlayamayacaksınız.',
    content_is_not_available: 'İçerik artık mevcut değil...',
    download_offline: 'Çevrimdışı indir',
    available_offline: 'Çevrimdışı mevcut',
    delete: 'Silmek',
    //Stores
    your_progress_in_stores: 'Mağazalardaki ilerlemeniz',
    map: 'Harita',
    daily_survey: 'Günlük anket',
    survey: 'Anket',
    matutino: 'SABAH',
    vespertino: 'AKŞAM',
    form: 'Form',
    enter_a_number: 'Bir numara girin',
    campaign_expiration: 'KAMPANYA SÜRESİ: ',
    store_indicators: 'Mağaza Göstergeleri',
    last_days: 'Son 30 gün içindeki verilere dayanmaktadır',
    main_indicators: 'Mağazadaki ana göstergelerin ilerlemesini görün',
    store_information: 'Optimum Mükemmel Mağaza seviyelerine ulaşmak için ilgili mağaza bilgilerini bulun',
    perform_executions: 'Mağaza durumu hakkında bilgi sahibi olmak için aşağıdaki işlemleri gerçekleştirin',
    pending_mayus: 'BEKLEMEDE',
    approved_mayus: 'ONAYLANDI',
    in_review_mayus: 'İNCELEMEDE',
    redo_mayus: 'YENİDEN YAP',
    visited_mayus: 'ZİYARET EDİLDİ',
    visited_mayus_sync: 'ZİYARET EDİLDİ SYNC',
    visited_store_mayus: 'ZİYARET EDİLEN MAĞAZALAR',
    checkin_realized_sync: 'ZİYARET EDİLEN MAĞAZALAR SYNC',
    moderation_mayus: 'MODERASYON',
    review_mayus: 'İNCELEME',
    in_progress_mayus: 'DEVAM EDİYOR',
    sync_pend_mayus: 'SENK. BEK.',
    locked_mayus: 'KİLİTLİ',
    complete_mayus: 'TAMAMLANDı',
    perfect_store: 'Mükemmel Mağaza',
    execution: 'Uygulama',
    vouchers: 'Kuponlar',
    send: 'Gönder',
    requires: 'Gerektirir ',
    variation: 'Değişken',
    validity: 'Geçerlilik: ',
    points: 'puan',
    voucher_canceled: 'Kupon iptal edildi',
    you_can_try_again: 'Endişelenmeyin! Yeniden deneyebilirsiniz.',
    voucher_successful: 'Kupon başarıyla kullanıldı!',
    successful_promo: 'Promosyon başarıyla tamamlandı!',
    voucher_pending: 'Kupon bekliyor',
    wait_for_the_validation: 'Kuponunuzun doğrulanmasını bekleyin',
    your_code_is_being_scanned: 'Kodunuz taranıyor ⏳',
    view_qr: 'QR Kodunu Görüntüle',
    return_to_store: 'Mağazaya Geri Dön',
    stores_objective: 'Mağazalar hedefini karşılamalıdır.',
    welcome_stores: 'Mağazalara hoş geldiniz!',
    tip_day: 'Burada gününüzdeki mağazalarınızı ziyaret edebilir, ilgili anketleri tamamlayabilir ve ilerlemenizi inceleyebilirsiniz.',
    close_mayus: 'KAPAT',
    select_form: 'Başlamak için bir form seçin',
    select_one_form: 'Anketi başlatmak için formlardan birini seçmelisiniz.',
    answer_all_questions: 'Devam edebilmek için tüm soruları cevaplamalısınız.',
    schedule_not_found: 'Bugünkü program bulunamadı.',
    form_not_found: 'Programda form bulunamadı.',
    send: 'Gönder',
    check_in: 'Giriş yap',
    check_out: 'Çıkış yap',
    check_out_done: 'Çıkış işlemi tamamlandı',
    off_route: 'Rotadan çıktınız, geri dönmek için buraya girin',
    search_barcode: 'Barkodla arama yap',
    no_agenda_today: 'Bugün için bir gündeminiz yok!',
    no_agenda_week: 'Hafta için bir gündeminiz yok!',
    no_information_today: 'Bu tarihte bir ajandanız bulunmamaktadır, sorularınız varsa lütfen sorumlu yönetici ile iletişime geçin.',
    no_information_week: 'Kullanıcı bilgileriniz alınamıyor, sorularınız varsa lütfen sorumlu yönetici ile iletişime geçin.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Kamera izinleriniz yok',
    activate_from_settings: 'Devam edebilmek için bunu cihazınızın ayarlarından etkinleştirin.',
    modify_permissions: 'İzinleri değiştir',
    complete_fields: 'Bir mağaza oluşturmak için aşağıdaki alanları doldurun',
    create: 'Oluştur',
    store_name: 'Mağaza Adı',
    enter_store_name: 'Mağaza adını girin',
    sore_address: 'Adres',
    enter_sore_address: 'Mağaza adresini girin',
    cluster: 'Küme',
    store_phone: 'Telefon',
    enter_sore_phone: 'Mağaza telefonunu girin',
    activate_survey: '1.1 Vespertino anketini etkinleştirmek için mağaza hedeflerini tamamlamanız gerekiyor. Hedefler: ',
    inactive_vespertino: 'Vespertino aktif değil',
    active_vespertino: 'Vespertino aktif',
    completed_your_mandatory_objectives: "Günün zorunlu hedeflerini tamamladınız, şimdi Vespertino'nuzu yapabilirsiniz.",
    complete_now: 'Şimdi tamamlayın',
    perform_later: 'Sonra yapın',
    back_to_your_agenda: 'Günün ajandanıza geri dönmek ister misiniz?',
    return_to_the_current_day: 'Önceki günlerin aktivitelerini görüntülüyorsunuz, devam et tuşuna basarsanız mevcut güne geri döneceksiniz: ',
    continue: 'Devam et',
    reached_your_goal: 'Hedefinize ulaştınız!',
    search_by_barcode: 'Barkod ile ara',
    scan_the_barcode: 'Bu anketin listesindeki herhangi bir ürünün barkodunu tarayın.',
    return_to_form: 'Formu Geri Dön',
    product_not_found: 'Ürün bulunamadı',
    code_does_not_match: 'Kod, bu formla ilgili herhangi bir ürünle eşleşmiyor.',
    search_another_product: 'Başka bir ürün ara',
    form_submitted_successfully: ' başarılı oldu!',
    send_new_survey: 'İsterseniz yeni bir anket gönderebilirsiniz.',
    no_agenda_for_today: 'Bugün için ajanda yok!',
    consult_your_supervisor: 'Bu tarih için ajandanız yok, herhangi bir sorunuz varsa süpervizörünüzle iletişime geçin.',
    visiting_your_store: 'Mağazanızı ziyaret ediyorsunuz ',
    you_can_check_out: 'Anketi tamamlamadan çıkış yapabilirsiniz: ',
    you_met_the_goal: 'Hedefe ulaştınız, formu doldurmanız gerekmiyor.',
    you_must_complete_the_survey: 'Çıkış yapmak için anketi tamamlamalısınız: ',
    checkin_blocked: 'Giriş engellendi',
    close_the_open_checkin: 'Devam etmek için açık olan girişi kapatmalısınız.',
    close_the_checkin_opened_in: 'Devam etmek için şu anda açık olan girişi kapatmalısınız: ',
    checkin_out_of_range: 'Giriş menzil dışında',
    more_meters_from_the_store: 'Mağazadan 150 metreden uzaktasınız.',
    now_is_your_turn: 'Şimdi sıra sizde!',
    surveys_in_progress: 'Devam eden anketleriniz var: ',
    unfinished_surveys: 'Tamamlanmamış anketleriniz var: ',
    want_to_checkout: 'Çıkış yapmak istediğinizden emin misiniz?',
    selected_store: 'Seçilen mağaza',
    checkout_blocked: 'Çıkış engellendi',
    uncompleted_forms: 'Tamamlanmamış formlarınız var!',
    checkout_anyway: 'Yine de çıkış yapmak istiyor musunuz?',
    go_to_survey: 'Ankete git',
    take_the_survey: 'Artık anketi tamamlayabilirsiniz!',
    validity: 'Geçerlilik: ',
    search_store: 'Mağazada ara...',
    no_results_for_your_search: 'Aramanız için sonuç bulunamadı',
    find_another_store: 'Başka bir mağaza bulun',
    //nuevos al 21-11-2024
    loading: 'Yükleniyor...',
    error_getting_data: 'Veri alınırken hata oluştu.',
    no_information_to_display: 'Görüntülenecek bilgi yok.',
    unzipping: 'Açılıyor...',
    saving: 'Kaydediliyor',
    loading_stores: 'Mağazalar yükleniyor...',
    getting_stores: 'Mağazalar alınıyor...',
    request_has_failed: 'Maksimum tekrar denemesi sayısına ulaşıldı. İstek başarısız oldu.',
    a_few_minutes: 'Mağazalar yükleniyor...\nBu işlem birkaç dakika sürebilir.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Perfect Store varlıkları indirildi',
    perfect_store_download: 'Perfect Store başarı fotoğrafı indirildi',
    perfect_store_error: 'Perfect Store varlıkları indirirken hata oluştu',
    connection_interrupted: 'Bağlantı kesildi, bağlantı geri geldiğinde başarı fotoğrafı açılacak',
    decompressing_perfect_store: 'Perfect Store indiriliyor',
    downloading_perfect_store: 'Perfect Store indiriliyor',
    saving_perfect_store: 'Perfect Store kaydediliyor',
    remain_downloaded: '\nİndirilecek kalan ',
    assets: ' varlık.',
    download_complete: 'İndirme tamamlandı',

    //Portfolio
    no_brands_to_show: 'Gösterilecek marka yok',
    no_products_to_show: 'Gösterilecek ürün yok',
    try_again_later: 'Daha sonra tekrar deneyin',
    portfolio: 'Portföy',
    select_one: 'Ürünlerini ve hizmetlerini görmek için markalardan birini seçin.',
    learn_about: 'Uygulamamızda sunulan tüm ürün ve hizmet yelpazesini keşfedin.',
    //nuevos al 01-08-2024
    brand: 'Marka',
    description: 'Açıklama',
    ingredients: 'İçindekiler',
    data_sheet: 'Teknik veri sayfası',

    //Benefits
    points_can_be_exchanged: 'Şunlarla değiştirilebilir:',
    approved: 'Onaylandı',
    cancelled: 'İptal edildi',
    pending: 'Beklemede',
    redeemed: 'KULLANILDI',
    added_points: 'PUANLAR EKLENDİ',
    all: 'Tümü',
    my_points: 'Puanlarım',
    your_points: 'Puanlarınız',
    delivered: 'Teslim edildi',
    no_benefits: 'Henüz hiçbir fayda yok',
    add_points: 'Puan kazanmak ve bunları kullanmak için etkileşimlerinizle puan kazanın',
    no_history: 'Henüz bir geçmiş yok',
    redeem_your_points: 'Puanlarınızı kullanın ve fayda geçmişinizi burada görün',
    pending_approval: 'Onay bekleniyor',
    when_it_is_approved: 'Onaylandığında, fayda geçmişinizde görünecektir',
    unredeemed_benefit: 'Kullanılmayan fayda',
    you_dont_have_enough_points: 'Bu faydayı kullanmak için yeterli puanınız yok',
    accept: 'Kabul et',
    units_available: ' birim mevcut',
    redeem_benefit: 'Faydayı kullan',
    benefits_mayus: 'FAYDALAR',
    history: 'GEÇMİŞ',
    there_was_a_mistake: 'Bir hata oluştu',

    //Vouchers
    complete_to_redeem_the_voucher: 'Kuponu kullanmak için tamamlayın',
    valid_until: 'Geçerli hasta: ',
    quantity_purchased: 'Satın alınan miktar: ',
    redeem: 'Kullan',
    lumps: 'Toplam',
    voucher_redeemed: 'Kupon başarıyla kullanıldı',
    error_redeeming_voucher: 'Kuponu kullanırken bir hata oluştu. Tekrar deneyin.',
    validate_and_redeem_vouchers: 'Kuponları doğrulayın ve kullanın',
    to_get_started: 'Başlamak için kuponunuzu kameranızla tarayarak veya kodunu yazarak girin',
    write_your_code: 'Kodunuzu yazın...',
    validate: 'Doğrula',
    back_to_store: 'Mağazaya Geri Dön',
    scan_qr: 'QR´yi tara',
    scan_on_the_voucher: 'Başlamak için, voucherdaki QR´yi tara',
    view_history: 'Geçmişi görüntüle',
    voucher_history: 'Voucher geçmişi',
    voucher_history_description:
        'Bu geçmiş, yapılan işlemleri doğru bir şekilde takip etmenizi sağlar ve biriktirdiğiniz ödüllerin takibi ve yönetimini kolaylaştırır.',
    see_more: 'Daha fazla göster',
    see_less: 'Daha az göster',

    //Faltantes
    upload_image: 'Resim Yükle',
    uploaded_image: 'Yüklenen Resim',
    photo: 'Fotoğraf',
    edit: 'Düzenle',
    delete: 'Sil',
    enter_a_comment: 'Bir Yorum Girin',
    enter_a_value: 'Bir Değer Girin',
    want_to_check_out: 'Çıkış yapmak istediğinizden emin misiniz?',
    not_check_in_again: 'Bir kez onaylandıktan sonra, bir sonraki ziyaretinize kadar tekrar giriş yapamayacaksınız.',

    //Alert
    alert: 'Uyarı',
    enter_characters: 'Önekinin ardından 10 karakter girmeniz gerekiyor',
    numerical_field: 'Düzenlenecek alan sayısal olmalıdır, boşluk veya harf olmadan.',
    enter_date_of_birth: 'Geçerli bir doğum tarihini YYYY-AA-GG formatında girin.',
    session_expired: 'Oturum süresi doldu',
    your_session_has_expired: 'Oturum süreniz doldu. Lütfen tekrar deneyin.',
    error: 'Hata',
    error_occurred: 'Şifreyi değiştirmeye çalışırken bir hata oluştu.',
    email_verification_code_incorrect: 'E-posta doğrulama kodu yanlış.',
    phone_verification_code_incorrect: 'Telefon doğrulama kodu yanlış.',
    no_checkin_found: 'Check-in bulunamadı.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
